import React from 'react';
import { RiPauseFill, RiPlayFill } from 'react-icons/ri';

interface PlayPauseButtonProps {
  isPlaying: boolean;
  disabled?: boolean;
  onClick: () => void;
}

export const PlayPauseButton: React.FC<PlayPauseButtonProps> = ({
  isPlaying,
  disabled = false,
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="bg-primary text-primary-foreground hover:bg-primary/90 flex size-9 shrink-0 items-center justify-center rounded-full transition-colors disabled:cursor-not-allowed disabled:opacity-50"
      aria-label={isPlaying ? '일시정지' : '재생'}
      title={isPlaying ? '일시정지' : '재생'}
    >
      {isPlaying ? <RiPauseFill className="text-xl" /> : <RiPlayFill className="text-xl" />}
    </button>
  );
};
